"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _SendFormContainer = _interopRequireDefault(require("../SendReceiveSidePane/SendForm/SendFormContainer"));
var _SendReceiveConfirmModalComponent = _interopRequireDefault(require("../SendReceiveSidePane/SendReceiveConfirmModal/SendReceiveConfirmModalComponent"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _transferActions = require("../../redux/actions/transferActions");
var _config = _interopRequireDefault(require("../../config"));
var _excluded = ["selectedAccountId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('fiat-withdraw-form');
var SendFiatTransfer = /*#__PURE__*/function (_React$Component) {
  function SendFiatTransfer(props) {
    var _this;
    _classCallCheck(this, SendFiatTransfer);
    _this = _callSuper(this, SendFiatTransfer, [props]);
    _defineProperty(_this, "onDataUpdate", function (data) {
      _this.setState({
        data: data
      });
    });
    _defineProperty(_this, "onSubmit", function (data) {
      _this.setState({
        isOpen: true,
        data: data
      });
    });
    _defineProperty(_this, "submitData", function () {
      _this.props.sendFunds(_objectSpread({
        selectedAccountId: _this.props.selectedAccountId,
        ProductId: _this.props.product.ProductId,
        Notes: ''
      }, _this.state.data));
    });
    _defineProperty(_this, "onChange", function (Amount) {
      _this.props.onChange(Amount);
    });
    _this.state = {
      isOpen: false,
      data: {}
    };
    return _this;
  }
  _inherits(SendFiatTransfer, _React$Component);
  return _createClass(SendFiatTransfer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        product = _this$props.product,
        balance = _this$props.balance;
      var data = this.state.data;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('send-to-friend')
      }, /*#__PURE__*/_react["default"].createElement(_SendFormContainer["default"], {
        product: product,
        balance: balance,
        onChange: function onChange(Amount) {
          return _this2.onChange(Amount);
        },
        onSubmit: this.onSubmit
      }), /*#__PURE__*/_react["default"].createElement(_SendReceiveConfirmModalComponent["default"], {
        product: product,
        values: data,
        total: data.Amount,
        isSend: true,
        fee: this.props.fee,
        isOpen: this.state.isOpen,
        close: function close() {
          return _this2.setState({
            isOpen: false
          });
        },
        onConfirm: this.submitData,
        hideFees: _config["default"].global.hideFees,
        useExternalAddress: false,
        TicketAmount: data.Amount
      }));
    }
  }]);
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    product: state.apexCore.product.products.find(function (i) {
      return i.ProductId === state.apexCore.position.selectedProductId;
    }),
    fee: state.withdraw.withdrawFee,
    selectedAccountId: state.user.selectedAccountId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    sendFunds: function sendFunds(_ref) {
      var selectedAccountId = _ref.selectedAccountId,
        rest = _objectWithoutProperties(_ref, _excluded);
      return dispatch((0, _transferActions.transferFunds)(rest, ownProps.name)).then(function () {
        return dispatch((0, _transferActions.getTransfers)(selectedAccountId));
      });
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SendFiatTransfer);